import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($filter, $scope, $translate, ModalService, StateUtils, submissionViewModel, DriverLicenseUtil) {
    var ctrl = Object.create(BaseCtrl);
    var flowModel = StateUtils.activeDataForState(true).flowModel;
    var submissionVm = submissionViewModel();
    var paModel = submissionVm.lobData.personalAuto.value;
    var accountHolder = submissionVm.value.getAccountHolderPerson();

    ctrl.init = function () {
        $scope.$filter = $filter;
        $scope.page = {
            drivers: submissionVm.lobData.personalAuto.coverables.drivers
        };
        $scope.documents = [];
        $scope.metadataTemplate = {
            docUID: '001',
            documentType: 'letter_received',
            securityType: 'unrestricted',
            status: 'approved'
        };
        $scope.errorUploading = false;
        var currentDriver = void 0;
        if (paModel.coverables.drivers.length === 0) {
            // If there are no drivers and this is the first visit, initialise a new driver
            currentDriver = paModel.coverables.createDriver(accountHolder);
        } else {
            // Select account holder
            // This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
            var sanitisePrefillDataFromQuickQuote = function sanitisePrefillDataFromQuickQuote(driver) {
                if (driver.licenseNumber === '0streamlinedquote0') {
                    driver.licenseNumber = undefined;
                    driver.yearLicensed = undefined;
                    driver.gender = undefined;
                }
            };
            currentDriver = paModel.coverables.getDriverForPerson(accountHolder);
            sanitisePrefillDataFromQuickQuote(currentDriver);
        }
        $scope.page.currentDriver = submissionVm.lobData.personalAuto.coverables.drivers.findFirstElement(currentDriver);
    };

    $scope.$watchCollection('documents', function (driverLicenses) {
        var currentDriver = $scope.page.currentDriver;
        if (driverLicenses.length >= 1) {
            var driverLicenseData = driverLicenses.pop();
            DriverLicenseUtil.setLicenseUploadProperties(currentDriver, driverLicenseData);
            if (!currentDriver.errorUploading) {
                DriverLicenseUtil.fillDriverInfo(currentDriver, driverLicenseData);
            }
        }
    });

    ctrl.isDriverValid = function () {
        return _.every($scope.page.drivers.children, function (driver) {
            return driver.aspects.subtreeValid;
        });
    };

    ctrl.addDriver = function (form) {
        form.submitted = true;

        if (!ctrl._isValid() || form.valid === false) {
            return;
        }

        if (ctrl._isValid(form)) {
            var paddr = submissionVm.baseData.policyAddress.value;
            var newPerson = submissionVm.value.createPerson({
                primaryAddress: paddr
            });

            var newDriver = paModel.coverables.createDriver(newPerson);
            $scope.page.currentDriver = submissionVm.lobData.personalAuto.coverables.drivers.findFirstElement(newDriver);
            $scope.page.currentDriver.isDriverLicenseScanned = false;
            $scope.page.currentDriver.errorUploading = false;
            $scope.$broadcast('update-form');
            form.submitted = false;
            form.setPristine();
        }
    };

    ctrl.editDriver = function (driver, form) {
        // Validate the current input, and if correct, save the current changes and select the next driver
        if (ctrl._isValid(form)) {
            $scope.page.currentDriver = submissionVm.lobData.personalAuto.coverables.drivers.findFirstElement(driver);
        }
    };

    ctrl.removeDriver = function (driver) {
        var msg = {
            key: 'quoteandbind.pa.controllers.PADriverDetailsCtrl.DriverRemovalMsg',
            args: {
                driver: driver.getDisplayName(undefined, $filter)
            }
        };

        ModalService.showWarning('quoteandbind.pa.controllers.PADriverDetailsCtrl.Remove Driver?', msg, '', $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.Yes'), 'gw-btn-primary', $filter('translate')('quoteandbind.pa.controllers.PADriverDetailsCtrl.No')).result.then(function () {
            var currentDriver = $scope.page.currentDriver.value;
            paModel.coverables.removeDriver(driver);

            // Updating the underlying model can cause the value of the vm node to become undefined, update here
            if (!$scope.page.currentDriver.value) {
                if (paModel.coverables.drivers.length === 0) {
                    // We deleted the only driver so create a new one
                    paModel.coverables.createDriver(accountHolder);
                }
                if (currentDriver === driver) {
                    // If deleted current driver: default to the first driver
                    $scope.page.currentDriver = submissionVm.lobData.personalAuto.coverables.drivers.findFirstElement(paModel.coverables.drivers[0]);
                } else {
                    // Otherwise: select the old current driver
                    $scope.page.currentDriver = submissionVm.lobData.personalAuto.coverables.drivers.findFirstElement(currentDriver);
                }
            }
            $scope.$broadcast('update-form');
        });
    };

    ctrl._isDriverEmpty = function (_ref) {
        var yearLicensed = _ref.yearLicensed,
            licenseState = _ref.licenseState,
            numberOfAccidents = _ref.numberOfAccidents,
            numberOfViolations = _ref.numberOfViolations,
            licenseNumber = _ref.licenseNumber,
            gender = _ref.gender;

        var nonLicenseFieldsEmpty = [yearLicensed, licenseNumber, gender, numberOfAccidents, numberOfViolations].every(function (prop) {
            return prop === null || prop === undefined || prop === '';
        });
        var licenseStateEmpty = licenseState === null || licenseState === undefined || licenseState === accountHolder.primaryAddress.state;
        return nonLicenseFieldsEmpty && licenseStateEmpty;
    };

    ctrl._isValid = function () {
        if (!ctrl.isDriverValid()) {
            return false;
        }
        var licenceMatchedDriver = ctrl._ensureUniqueLicenseNumber($scope.page.currentDriver.value);
        if (licenceMatchedDriver) {
            var msg = $translate('quoteandbind.pa.controllers.PADriverDetailsCtrl.LicenceMatchMsg', {
                driver: licenceMatchedDriver.getDisplayName(undefined, $filter)
            });
            ModalService.showError('quoteandbind.pa.controllers.PADriverDetailsCtrl.Licence number is not unique', msg);

            return false;
        }
        return true;
    };

    ctrl._ensureUniqueLicenseNumber = function (driver) {
        var driverMatch = _.where(paModel.coverables.drivers, {
            licenseNumber: driver.licenseNumber
        });
        if (!driverMatch) {
            return undefined;
        } else if (driverMatch.length === 1) {
            return driverMatch[0] !== driver ? driverMatch : undefined;
        }
        return _.find(driverMatch, function (d) {
            return d !== driver;
        });
    };

    ctrl.next = function (form) {
        form.submitted = true;
        if (!ctrl._isValid() || form.valid === false) {
            return;
        }
        flowModel.next(submissionVm);
    };
    ctrl.previous = function () {
        // remove empty driver if no changes have been made
        if (paModel.coverables.drivers.length === 1 && ctrl._isDriverEmpty(paModel.coverables.drivers[0])) {
            paModel.coverables.drivers.pop();
        }
        flowModel.previous(submissionVm);
    };
    ctrl.cancel = function () {
        flowModel.cancel(submissionVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$filter', '$scope', '$translate', 'ModalService', 'StateUtils', 'submissionViewModel', 'DriverLicenseUtil'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/controllers/PADriverDetailsCtrl.js
// module id = 2165
// module chunks = 0